import a11yEmoji from "@fec/remark-a11y-emoji";
import { serialize } from "next-mdx-remote/serialize";
import remarkEmoji from "remark-emoji";
import remarkGfm from "remark-gfm";

import { ListIcon } from "@/components/onboardingSections/inputs";
import styles from "@/styles/onboarding.module.scss";

export const convertMDX = async (data, needModification = true) => {
  const mdxDataSource = needModification ? data.replace("<br>", " ") : data;
  const mdxSource = await serialize(mdxDataSource, {
    mdxOptions: {
      remarkPlugins: [remarkEmoji, remarkGfm, a11yEmoji],
      format: "mdx",
      development: process.env.NODE_ENV === "development",
    },
  });
  return mdxSource;
};

export const mdxToJsxComponents = {
  h1: props => (
    <p className={`${styles.topTitle} text-center !mb-10`}>{props.children}</p>
  ),
  h2: props => <p className="font-medium">{props.children}</p>,
  strong: props => <p className="font-medium">{props.children}</p>,
  ul: props => <p className="gap-6 list-disc md:ml-4">{props.children}</p>,
  li: props => <li className="pl-3 md:pl-6">{props.children}</li>,
  blockquote: props => <ListIcon text={props.children} />,
  a: props => (
    <a href={props.href} className="underline underline-offset-2">
      {props.children}
    </a>
  ),
};

export const mdxToJsxComponentsForAPR = {
  h1: props => (
    <p className={`${styles.topTitle} text-center !mb-10`}>{props.children}</p>
  ),
  h2: props => <p className="font-medium">{props.children}</p>,
  h3: props => <p className="font-medium text-xl">{props.children}</p>,
  h4: props => <p className="font-medium text-md">{props.children}</p>,
  strong: props => <strong className="font-medium">{props.children}</strong>,
  ul: props => <p className="gap-6 list-disc md:ml-4">{props.children}</p>,
  li: props => <li className="pl-3 md:pl-6">{props.children}</li>,
  blockquote: props => <ListIcon text={props.children} />,
  a: props => (
    <a href={props.href} className="underline underline-offset-2">
      {props.children}
    </a>
  ),
};

export const mdxToJsxCustomerCare = {
  p: props => <p className="customer-care-p mt-4">{props.children}</p>,
  h3: props => <h3 className="text-3xl md:text-4xl">{props.children}</h3>,
  label: props => (
    <label className="customer-care-p mt-4">{props.children}</label>
  ),
  div: props => <div className="customer-care-p mt-4">{props.children}</div>,
  h1: props => (
    <div
      style={{
        marginBottom: "2.5rem",
      }}
    >
      <h1 className="text-3xl md:text-4xl font-semibold text-center">
        {props.children}
      </h1>
    </div>
  ),
  h2: props => (
    <div
      style={{
        marginTop: "2.5rem",
      }}
    >
      <p className="customer-care-h2 font-semibold">{props.children}</p>
    </div>
  ),
  h4: props => (
    <p className="customer-care-h2 font-semibold">{props.children}</p>
  ),
  strong: props => <b className="font-medium">{props.children}</b>,
  ul: props => (
    <div
      style={{
        marginBottom: "1.5rem",
      }}
    >
      <p className="gap-6 fs-3 list-disc lg:ml-4">{props.children}</p>
    </div>
  ),
  li: props => (
    <li className="pl-3 lg:pl-6 customer-care-li">{props.children}</li>
  ),
  ol: props => (
    <ol
      style={{
        listStyleType: "decimal",
        marginLeft: "2rem",
      }}
    >
      {props.children}
    </ol>
  ),
  blockquote: props => <strong>{props.children}</strong>,
  a: props => (
    <a
      href={props.href}
      className="underline underline-offset-2 text-onmoPrimary"
    >
      {props.children}
    </a>
  ),
  table: props => (
    <table
      style={{
        width: "100%",
        marginTop: "1.3rem",
        borderWidth: "2px",
      }}
      className="customer-care-p"
    >
      {props.children}
    </table>
  ),
  tbody: props => (
    <tbody
      style={{
        width: "100%",
        textAlign: "center",
        borderWidth: "2px",
      }}
    >
      {props.children}
    </tbody>
  ),
  td: props => (
    <td
      style={{
        wordBreak: "break-all",
      }}
    >
      {props.children}
    </td>
  ),
};

export const mdxToJsxComponentsDeclinedHeading = {
  p: props => <p className="text-center">{props.children}</p>,
  strong: props => (
    <strong className="text-3xl md:text-[30px] text-center font-medium">
      {props.children}
    </strong>
  ),
};

export const mdxToJsxComponentsDeclined = {
  a: props => (
    <a href={props.href} className="underline underline-offset-2">
      {props.children}
    </a>
  ),
};

export const mdxFaqComponent = {
  a: props => (
    <a href={props.href} className="underline text-purple-faq">
      {props.children}
    </a>
  ),
};
